import React, { useState, useContext, useEffect } from 'react'
import './Footer.css'
import AutopltContext from '@/product/context/autopilot/autopltContext'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { LOGO, SITE_NAME } from '@/utils'
import { Link } from 'react-router-dom'

const Footer = () => {
    const autopltContext = useContext(AutopltContext)

    const { addCustomer, responseStatus: responseStatusAutoPlt } = autopltContext

    const validationArray = Yup.object({
        email: Yup.string().email('Invalid email format').required('Required'),
    })

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            addCustomer(values)
        },
    })

    const subscribe = [
        {
            label: 'Subscribe to our mailing list',
            placeholder: 'Enter your email address',
            class: 'subsInp',
            type: 'text',
            variant: 'filled',
            name: 'email',
            formik: formik,
        },
    ]

    useEffect(() => {
        if (responseStatusAutoPlt) {
            if (responseStatusAutoPlt.from === 'addCustomer') {
                if (responseStatusAutoPlt.status === 'success') {
                    formik.values.email = ''
                }
            }
        }
    }, [responseStatusAutoPlt])

    return (
        <footer className="noPrint">
            <div className="footCnt customContainer">
                <div className="footTop">
                    <img className="footerLogo" src={LOGO} alt={SITE_NAME} />
                    <div className="footLinks">
                        <ul>
                            <li>
                                {/* <Link id="footer_tg" to="/timeGivers"> */}
                                <a
                                    id="footer_tg"
                                    href="https://www.timetogive.network/timegivers"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    TimeGivers
                                </a>
                                {/* </Link> */}
                            </li>
                            <li>
                                {/* <Link id="footer_tb" to="/timeBidders"> */}
                                <a
                                    id="footer_tb"
                                    href="https://www.timetogive.network/timebidders"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    TimeBidders
                                </a>

                                {/* </Link> */}
                            </li>
                            <li>
                                {/* <Link id="footer_charities" to="/charities"> */}
                                <a
                                    id="footer_charities"
                                    href="https://www.timetogive.network/charities"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    Charities
                                </a>
                                {/* </Link> */}
                            </li>
                            <li>
                                {/* <Link id="footer_sponsors" to="/sponsors"> */}
                                <a
                                    id="footer_sponsors"
                                    href="https://www.timetogive.network/sponsors"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    Sponsors
                                </a>
                                {/* </Link> */}
                            </li>
                            <li>
                                <a
                                    id="footer_sponsors"
                                    href=" https://www.timetogive.network/get-in-touch"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    Contact
                                </a>
                                {/* <Link id="footer_contact" to="/contact">
                                    {'Contact'}
                                </Link> */}
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <a
                                    id="footer_about"
                                    href="https://www.timetogive.network/about"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    About
                                </a>
                            </li>
                            <li>
                                {/* <Link id="footer_faqs" to="/faqs"> */}
                                <a
                                    id="footer_faqs"
                                    href="https://www.timetogive.network/faqs"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    FAQs
                                </a>
                                {/* </Link> */}
                            </li>
                            <li>
                                {/* <Link id="footer_get_involved" to="/getInvolved"> */}
                                <a
                                    id="footer_get_involved"
                                    href="https://www.timetogive.network/sign-up"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    Get Involved
                                </a>
                                {/* </Link> */}
                            </li>
                            <li>
                                <a
                                    id="linked_in"
                                    href="https://www.linkedin.com/company/time-to-give-network/about/"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    LinkedIn
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footCopyright text-center" dir="ltr">
                    <p>
                        {' '}
                        © {SITE_NAME} {new Date().getFullYear()}. All rights reserved |{' '}
                        <a
                            id="footer_privacy_policy"
                            href="https://www.timetogive.network/privacy-policy"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Privacy and cookie policy
                        </a>
                        {/* <Link to="/privacy">Privacy</Link> and{' '}
                        <Link to="/cookie_policy">cookie policy</Link> */}
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default Footer
